<template>
    <CalendarNext
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-right"
        size="sm"
        tooltipText="Next month"
    >
    </CalendarNext>
</template>

<script lang="ts" setup>
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';

import { reactiveOmit } from '@vueuse/core';
import type { CalendarNextProps } from 'reka-ui';
import { CalendarNext, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarNextProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
